/**
 * @ngdoc service
 * @name common.shopCart.service:ItxShopCartFct
 * @requires $rootScope
 * @requires $window
 * @requires $q
 * @requires ItxColbensonTaggingSvc
 * @requires ItxErrorMessagesFct
 * @description
 * Shop cart service.
 */
 (function () {
    'use strict';

    angular.module('itxApp.common').factory('ItxShopCartFct', ItxShopCartFct);

    ItxShopCartFct.$inject = [
        '$rootScope',
        '$q',
        'ItxColbensonTaggingSvc',
        'ItxErrorMessagesFct',
        'ngDialog',
        'ItxTranslateSvc',
        'imEventServiceWrapper',
        'NavigationService',
        'imProductService',
        'ShopCartPackagingService',
        'DialogSvc',
        'CmsConfigSvc',
        'ProductRelatedSvc',
        'mdUtils',
        'Product',
        'ShopCartPackagingErrorService'
    ];

    function ItxShopCartFct(
        $rootScope,
        $q,
        ItxColbensonTaggingSvc,
        ItxErrorMessagesFct,
        ngDialog,
        ItxTranslateSvc,
        imEventServiceWrapper,
        NavigationService,
        imProductService,
        ShopCartPackagingService,
        DialogSvc,
        CmsConfigSvc,
        ProductRelatedSvc,
        mdUtils,
        Product,
        ShopCartPackagingErrorService
    ) {
        var _this = this;

        function CartItems(product) {
            var color = product.state.selectedColor;
            var size = product.state.selectedSize;
            if (!color) {
                color = product.status.selectedColor;
                size = product.status.selectedSize
            }
            return [{
                parentId: product.id,
                productType: product.productType,
                name: product.name,
                image: color.image,
                color: color.name,
                colorId: color.id,
                parentReference: product.activeDetail.reference,
                reference: size.partnumber,
                size: size.name,
                sku: size.sku,
                unitPrice: size.price,
                quantity: product.quantity || 1,
                xmedia: product.activeDetail.xmedia,
                xmediaDefaultSet: product.activeDetail.xmediaDefaultSet
            }];
        }

        _this.messages = {
            notStock: ItxTranslateSvc.translateCms('legacy.Messages_withoutStock'),
            notAvailable: ItxTranslateSvc.translateCms('legacy.Messages_notAvailable'),
        };

        _this.maxItems = inditex.iMaxProductsShopCart;
        _this.validCart = true;
        _this.shopCartPage = 'ItxShopCartPage';
        _this.stockErrorMeccano = false;

        _this.shopCart = {};

        CmsConfigSvc.getProperty('enable_add_product_popup').then(function (addToCartPopupEnabled) {
            _this.addToCartPopupEnabled = addToCartPopupEnabled;
        });

        inditex.onReady(function () {
            if (inditex.iPage !== _this.shopCartPage && inditex.iUserJSON && inditex.iUserJSON.shopCart) {
                _this.shopCart = _saveDataShopcart(inditex.iUserJSON.shopCart);
            }
        });

        document.addEventListener('legacy-event-cart', function (event) {
            _saveDataShopcart(event.detail.cart);
        });

        var service = {
            shopCart: _this.shopCart,
            addToCart: _addToCart,
            addCart: _addCart,
            generateCartItem: _generateCartItem,
            addMultipleProductsToCart: _addMultipleProductsToCart,
            getCart: _getCart,
            updateCart: _updateCart,
            changeSize: _changeSize,
            deleteFromCart: _deleteFromCart,
            canIAddItems: _canIAddItems,
            goToShopCart: _goToShopCart,
            isValidCart: isValidCart,
            processCart: processCart,
            hasVirtualCard: hasVirtualCard,
            shopcartMerged: shopcartMerged,
            deleteItemsOutOfStock: deleteItemsOutOfStock,
            getMessagesError: getMessagesError,
            getMessageError: getMessageError,
            newItemCart: ItemCart,
            getState: _getState,
            getFreeShippingOver: _getFreeShippingOver,
            processSubDivisionCart: _processSubDivisionCart,
            addCartApollo: _addCartApollo,
            addMultipleProductCartApollo: _addMultipleProductCartApollo,
            haveIndomError: haveIndomError
        };
        return service;

        function getMessageError() {
            var textError = getMessagesError();
            return textError['error' + _this.shopCart.state.errors];
        }

        function _getState() {
            if (inditex.iUserJSON) {
                return _saveDataShopcart(inditex.iUserJSON.shopCart);
            } else {
                return _this.shopCart;
            }
        }

        function getMessagesError() {
            return {
                error115: ItxTranslateSvc.translateCms('legacy.ItxShopCart.help.error115'),
                error115Help: ItxTranslateSvc.translateCms('legacy.ItxShopCart.help.error115Help'),
                error116: ItxTranslateSvc.translateCms('legacy.ItxShopCart.help.error116'),
                error117: ItxTranslateSvc.translateCms('legacy.ItxShopCart.help.error117'),
                errorMethods120: ItxTranslateSvc.translateCms('legacy.ItxShopCart.help.errorMethods120'),
                errorGiftPacking120: ItxTranslateSvc.translateCms('legacy.ItxShopCart.help.errorGiftPacking120'),
                goToShopCart: ItxTranslateSvc.translateCms('legacy.ItxShopCart.help.navigateShopcart'),
                error115buylater: ItxTranslateSvc.translateCms('legacy.ItxShopCart.help.error115buylater'),
                error117buylater: ItxTranslateSvc.translateCms('legacy.ItxShopCart.help.error117buylater'),
                errorStockMeccano: ItxTranslateSvc.translateCms('dev.shopCart.error.quantityNotAvaliable')
            };
        }

        /**
         * @ngdoc method
         * @name _canIAddItems
         * @methodOf  common.shopCart.service:ItxShopCartFct
         * @description
         * Check if can I add more items to the shopcart.
         * If not show a modal to inform user that has reach the max amount of items
         * @returns {Boolean} Able or not to add items
         */
        function _canIAddItems() {
            // There is place for your item.
            if (_this.shopCart && !_this.shopCart.items) {
                return true;
            }
            if (_this.shopCart === undefined) {
                return true;
            }
            if (_this.shopCart && _this.shopCart.items && _this.shopCart.items.length + 1 <= _this.maxItems) {
                return true;
            }
            // Sorry but there is no place for more items.
            var dialog = {
                template: 'ItxShopCartMaxItemsDialog.html',
                className: 'ngdialog-theme-plain ngdialog size-detail-layout ',
                showClose: false,
                data: {
                    message: ItxTranslateSvc.translateCms('legacy.ItxShopCart.maxItems'),
                    button: ItxTranslateSvc.translateCms('legacy.ItxHeaderDisplay.shopCart'),
                    goToShopCart: _goToShopCart
                }
            };

            ngDialog.open(dialog);

            return false;
        }

        /**
         * ngdoc method
         * @methodOf common.shopCart.service:ItxShopCartFct
         * @name goToShopCart
         * @description
         * Navigate to shop cart.
         */
        function _goToShopCart() {
            NavigationService.goToShopCartPage();
        }
        /**
         * @ngdoc method
         * @name _addToCart
         * @methodOf  common.shopCart.service:ItxShopCartFct
         * @description
         * Add an item list to the shopping cart. _this.shopCart will be updated accordingly.
         *
         * @param {Object} product product object
         * @param {Object} color color object
         * @param {Object} size size object
         * @param {Number} quantity item quantity
         *
         *** THIS FUNCTION IS A DEPRECATED FUNCTION ***
         */
        function _addMultipleProductsToCart(cartItems, products) {
            // debugger
            try {
                if (window.initEmpathyX && EmpathyX) {
                    cartItems.forEach((elem) => {
                        EmpathyX.productPage(elem.id);
                        EmpathyX.addToCartOnProductPageClicked();
                    });
                }
            } catch (error) {
                console.log('ERROR EMPATHY', error);
            }

            var action = {
                action: 'order:addToCart',
                params: {
                    storeId: inditex.iStoreId,
                    languageId: inditex.iLangId
                },
                data: {
                    cartItems: cartItems
                }
            };

            var deferred = $q.defer();

            joyr.rest
                .xRestExecute([action])
                .done(function (response) {
                    products.forEach((product) => {
                        ItxColbensonTaggingSvc.trackConversion(product);
                        imProductService.eventAddToCart(product);
                    });
                    _getCart();

                    deferred.resolve(response);
                })
                .Catch(function (error) {
                    _handleErroShopcart(error);
                    deferred.reject(error);
                });
            return deferred.promise;
        }

        function _generateCartItem(product, color, size, quantity) {
            var cartItems = {
                parentId: product.id,
                productType: product.productType,
                name: product.name,
                image: color.image,
                color: color.name,
                colorId: color.id,
                parentReference: product.activeDetail.reference,
                reference: size.partnumber,
                size: size.name,
                sku: size.sku,
                unitPrice: size.price,
                quantity: quantity || 1,
                xmedia: product.activeDetail.xmedia,
                xmediaDefaultSet: product.activeDetail.xmediaDefaultSet
            };

            if (product.customization) {
                cartItems.customization = [product.customization];
                // La API no soporta este nuevo atributo(se añade para gestionar los colores desde cms) y lo acepta con HOTSTAMPING
                if (product.customization.datatype === 'HOTSTAMPING_ENGRAVED') {
                    product.customization.datatype = 'HOTSTAMPING';
                }
            }

            // Añade el set de la imagen en caso de existir
            if (product.state.imageSet) {
                cartItems.style = product.state.imageSet;
            }

            // HERACLES no acepta el style a 0, debe ser NULL
            if (product.state.imageSet == 0) {
                cartItems.style = null;
            }
            return cartItems;
        }
        /**
         * @ngdoc method
         * @name _addToCart
         * @methodOf  common.shopCart.service:ItxShopCartFct
         * @description
         * Add an item list to the shopping cart. _this.shopCart will be updated accordingly.
         *
         * @param {Object} product product object
         * @param {Object} color color object
         * @param {Object} size size object
         * @param {Number} quantity item quantity
         *
         *** THIS FUNCTION IS A DEPRECATED FUNCTION ***
         */
        function _addToCart(product, color, size, quantity, force) {
            // debugger
            const cartItems = [_generateCartItem(product, color, size, quantity)];

            try {
                if (window.initEmpathyX && EmpathyX) {
                    EmpathyX.productPage(product.id);
                    EmpathyX.addToCartOnProductPageClicked();
                }
            } catch (error) {
                console.log('ERROR EMPATHY', error);
            }

            var action = {
                action: 'order:addToCart',
                params: {
                    storeId: inditex.iStoreId,
                    languageId: inditex.iLangId
                },
                data: {
                    cartItems: cartItems
                }
            };

            var deferred = $q.defer();

            joyr.rest
                .xRestExecute([action])
                .done(function (response) {
                    ItxColbensonTaggingSvc.trackConversion(product);

                    //if(inditex.iPage === _this.shopCartPage || force) {
                    _getCart();
                    //} else {
                    //    _this.shopCart = _saveDataShopcart( inditex.iUserJSON.shopCart );
                    //}

                    imProductService.eventAddToCart(product);
                    deferred.resolve(response);
                })
                .Catch(function (error) {
                    _handleErroShopcart(error);
                    deferred.reject(error);
                });

            return deferred.promise;
        }

        function _addCartApollo(product, openPopup, preventAnalytics, customized) {
            const legacyProduct = new Product(product, product.status.selectedColor.id, null, null, product.status.selectedSize.sku);
            return _addCart(legacyProduct, openPopup, preventAnalytics, customized);
        }

        function haveIndomError() {
            // variable que indica que el articulo viene de sint
            let isSint = '2';
            _this.indomError = _this.shopCart.items.some((item) => item.stockLocations && item.stockLocations[0].stockLocationId === isSint);
            if (_this.indomError && inditex.iUserJSON.shopCart.giftPacking) {
                ShopCartPackagingErrorService.deleteOnlyGiftPacking();
                ShopCartPackagingErrorService.openModalGiftError(_this.shopCart);
            }
        }

        function _addMultipleProductCartApollo(products, bundle, openPopup) {
            var cartItems = [];
            var legacyProducts = [];
            products.forEach(product => {
                const legacyProduct = new Product(product, product.status.selectedColor.id, null, null, product.status.selectedSize.sku);
                legacyProducts = legacyProducts.concat(legacyProduct);
                cartItems = cartItems.concat(new CartItems(legacyProduct));
            })
            return _addMultipleProductsToCart(cartItems, legacyProducts).then(function (res) {
                bundle.state = {};
                bundle.state.bundleItemsAdded = legacyProducts;
                bundle.isBundleBean = true;
                ProductRelatedSvc.openPopupRelateds(angular.copy(bundle));
            });
        }

        /**
         * @ngdoc method
         * @name _addToCart
         * @methodOf  common.shopCart.service:ItxShopCartFct
         * @description
         * Add an item list to the shopping cart. _this.shopCart will be updated accordingly.
         *
         * @param {Object} product product object
         * @param {Boolean} openPopup open popup addtocart relateds
         * @param {Boolean} force force getCart(POST API)
         */
        function _addCart(product, openPopup, preventAnalytics, customized) {
            var deferred = $q.defer();

            if (!service.canIAddItems()) {
                return;
            }

            if (!joyr.catalog.utils.isOpenForSale()) {
                return;
            }

            var cartItems = new CartItems(product);

            if (product.customization) {
                cartItems[0].customization = [product.customization];
            }

            // Añade el set de la imagen en caso de existir
            if (product.state.imageSet) {
                cartItems[0].style = product.state.imageSet;
            }

            // HERACLES no acepta el style a 0, debe ser NULL
            if (product.state.imageSet == 0) {
                cartItems[0].style = null;
            }

            try {
                if (window.initEmpathyX && EmpathyX) {
                    EmpathyX.productPage(product.id);
                    EmpathyX.addToCartOnProductPageClicked();
                }
            } catch (error) {
                console.log('ERROR EMPATHY', error);
            }

            var action = {
                action: 'order:addToCart',
                params: {
                    storeId: inditex.iStoreId,
                    languageId: inditex.iLangId
                },
                data: {
                    cartItems: cartItems
                }
            };

            joyr.rest
                .xRestExecute([action])
                .done(function (response) {
                    ItxColbensonTaggingSvc.trackConversion(product);

                    //if(inditex.iPage === _this.shopCartPage || force) {
                    _getCart();
                    //} else {
                    //    _this.shopCart = _saveDataShopcart( inditex.iUserJSON.shopCart );
                    //}

                    if (openPopup && _this.addToCartPopupEnabled) {
                        ProductRelatedSvc.openPopupRelateds(angular.copy(product), customized);
                    }

                    if (!preventAnalytics) {
                        imProductService.eventAddToCart(product);
                    }
                    deferred.resolve(response);
                })
                .Catch(function (error) {
                    _handleErroShopcart(error);
                    deferred.reject(error);
                });

            return deferred.promise;
        }

        /**
         * @ngdoc method
         * @name _addToCart
         * @methodOf  common.shopCart.service:ItxShopCartFct
         * @description
         * Synchronizes the shopCart
         */
        function _getCart() {
            var deferred = $q.defer();

            var action = {
                action: 'order:shoppingCart',
                params: {
                    storeId: inditex.iStoreId,
                    languageId: inditex.iLangId
                }
            };

            const options = {
                bubbles: true,
                composed: true,
                detail: {
                    extra: {
                        typeEvent: 'update-cart-legacy'
                    }
                }
            };
            document.dispatchEvent(new CustomEvent('legacy-event-apollo', options));

            joyr.rest
                .xRestExecute([action])
                .done(function (response) {
                    _this.shopCart = _saveDataShopcart(response[0]);
                    deferred.resolve(_this.shopCart);
                })
                .Catch(function (error) {
                    _handleErroShopcart(error);
                    deferred.reject(error);
                });

            return deferred.promise;
        }

        /**
         * @ngdoc method
         * @name _addToCart
         * @methodOf  common.shopCart.service:ItxShopCartFct
         * @description
         * Synchronizes the shopCart
         */
        function _processSubDivisionCart() {
            var orders = {};
            _this.shopCart.items.forEach((item) => {
                if (item.stockLocations && item.stockLocations[0].stockLocationId) {
                    if (orders[item.stockLocations[0].stockLocationId]) {
                        orders[item.stockLocations[0].stockLocationId].push(item);
                    } else {
                        orders[item.stockLocations[0].stockLocationId] = [item];
                    }
                }
            });
            return orders;
        }

        /**
         * @ngdoc method
         * @name _updateCart
         * @methodOf  common.shopCart.service:ItxShopCartFct
         * @description
         * Update the shopping cart. _this.shopCart will be updated accordingly.
         * @param {object} cartItems - Item id and Quantity
         * @param {Object[]} cartItems - An array of CartItem objects containing information about the items to be
         *  updated (or added, if not present).
         * @param {number} id - The ID of the cart item to update. The cart item must already by part of the shopping
         *  cart.
         * @param {number} quantity - The new number of items of this SKU in the cart. If it is 0, the cart item will be
         *  removed from the cart.
         */
        function _updateCart(cartItems, getItemsCart = true) {
            // debugger
            var action = {
                action: 'order:updateCart',
                params: {
                    storeId: inditex.iStoreId,
                    languageId: inditex.iLangId
                },
                data: {
                    cartItems: cartItems
                }
            };

            var deferred = $q.defer();

            joyr.rest
                .xRestExecute([action])
                .done(function (response) {
                    _this.stockErrorMeccano = false;
                    if (getItemsCart) {
                        _getCart();
                    }
                    deferred.resolve(response);
                })
                .Catch(function (error) {
                    if (error.errorKey == 'OUT_OF_STOCK') {
                        _this.stockErrorMeccano = true;
                        //_getCart();
                        _this.shopCart = _saveDataShopcart(_this.shopCart);
                        imEventServiceWrapper.sendServerUnidadeStock(cartItems, _this.shopCart);
                    }
                    ItxErrorMessagesFct.add(error, 'shopcart', 'ERROR');
                    deferred.reject(error);
                });

            return deferred.promise;
        }

        /**
         * @ngdoc method
         * @name _deleteFromCart
         * @methodOf  common.shopCart.service:ItxShopCartFct
         * @description
         * Removes all items of a specific SKU from the shopping cart. _this.shopCart will be updated
         * @param {number} sku - The ID of the SKU to be removed from the cart.
         */
        function _deleteFromCart(sku) {
            // debugger
            var deferred = $q.defer();
            var action = {
                action: 'order:deleteFromCart',
                params: {
                    storeId: inditex.iStoreId,
                    sku: sku,
                    languageId: inditex.iLangId
                }
            };

            joyr.rest
                .xRestExecute([action])
                .done(function (response) {
                    _this.getCart();
                    deferred.resolve(response);
                })
                .Catch(function (error) {
                    ItxErrorMessagesFct.add(error, 'shopcart', 'ERROR');
                    deferred.reject(error);
                });
            return deferred.promise;
        }

        function _changeSize(item, value) {
            var deferred = $q.defer();
            return _updateCart([{
                    id: item.id,
                    quantity: 0
                }], false)
                .then((data) => {
                    _addCart(value.item);
                    deferred.resolve(data);
                })
                .catch((error) => {
                    deferred.reject(error);
                });
            /*
            var deferred = $q.defer();
            var promises = [];
            promises.push(_updateCart([{ id: item.id, quantity: 0 }], false));
            promises.push(_addCart(value.item));
            $q.all(promises)
                .then(function (data) {
                    deferred.resolve(data);
                })
                .catch(function (data) {
                    deferred.resolve(data);
                });
            return deferred.promise;*/
        }

        function isValidCart() {
            return _this.validCart;
        }

        function deleteItemsOutOfStock() {
            var deferred = $q.defer();

            // TODO agrupar
            var items = _this.shopCart.items.filter(function (item) {
                if (item.availability !== 'in_stock' || item.quantity > item.unitsAvailable) {
                    return true;
                } else {
                    return false;
                }
            });
            var itemsRemoved = [];
            var itemsRemove = _.map(items, function (item) {
                var quantity = 0;
                // item.availability === 'in_stock'
                if (item.quantity > item.unitsAvailable) {
                    quantity = item.unitsAvailable;
                    itemsRemoved = _.concat(itemsRemoved, item);
                }
                return {
                    id: item.id,
                    quantity: quantity
                };
            });
            _updateCart(itemsRemove).then(function () {
                deferred.resolve({
                    itemsRemoved: itemsRemoved,
                    items: items
                });
            });
            return deferred.promise;
        }

        function _validateCart(shopCart) {
            if (shopCart && shopCart.items) {
                ItxErrorMessagesFct.reset('shopCartCtrl', 'WARNING');
                //Check stock problems
                if (
                    shopCart.items.filter(function (item) {
                        return (
                            item.availability !== 'in_stock' || item.quantity > item.unitsAvailable
                        );
                    }).length > 0
                ) {
                    _this.validCart = false;
                } else {
                    _this.validCart = true;
                }
                //Check VC problems
                var noVCItems = shopCart.items.filter(function (item) {
                    return item.productType !== 'Virtual Card';
                }).length;
                var vCItems = shopCart.items.filter(function (item) {
                    return item.productType === 'Virtual Card';
                }).length;
                if (noVCItems > 0 && vCItems > 0) {
                    _this.validCart = false;
                    ItxErrorMessagesFct.add(ItxTranslateSvc.translateCms('legacy.Messages_errorTarjetaVirtual'), 'shopCartCtrl', 'WARNING');
                }
                // Check tailoring problems
                _.each(shopCart.items, function (item) {
                    if (item.itemType === 1) {
                        _.each(shopCart.items, function (item) {
                            if (item.itemType !== 1 && item.itemType !== 6) {
                                _this.validCart = false;
                            }
                        });
                    }
                });
                // Check Indom Error Sint
                if (_this.shopCart.indomError && !_this.stockErrorMeccano) {
                    _this.validCart = false;
                }
            }
        }

        function processCart() {
            if (_this.validCart) {
                if (inditex.iUserJSON.userType === 'G') {
                    NavigationService.goToAuthPage();
                } else {
                    NavigationService.goToAngularCheckoutPage();
                }
                // IMAnalytics siguiente paso
                imEventServiceWrapper.sendBasicAnalytics('checkout', 'cesta', 'siguiente_paso');
            }
        }

        /**
         * @ngdoc method
         * @name _getItemsQuantity
         * @methodOf  common.shopCart.service:ItxShopCartFct
         * @description
         * Update cart items
         */
        function _getItemsQuantity(shopCart) {
            var totalItems = 0;
            for (var i = 0; i < shopCart.items.length; i++) {
                var item = shopCart.items[i];
                if (item.name !== 'XGIFT') {
                    totalItems += item.quantity;
                }
            }
            return totalItems;
        }
        /**
         * @ngdoc method
         * @name _getTotalProduct
         * @methodOf  common.shopCart.service:ItxShopCartFct
         * @description
         * Update cart items
         */
        function _getTotalProduct(shopCart) {
            var price = 0;
            _.each(shopCart.items, function (p) {
                var priceProduct = p.quantity * p.unitPrice;
                if (!p.isAutoAdd) {
                    price = price + priceProduct;
                }
            });
            if (!price || price < 0 || isNaN(price)) {
                price = shopCart.totalProduct;
            }
            return price;
        }

        /**
         * @ngdoc method
         * @name _getFreeShippingOver
         * @methodOf  common.shopCart.service:ItxShopCartFct
         * @description
         * Get info about free shiping
         */
        function _getFreeShippingOver(shopCart) {
            var deferred = $q.defer();

            CmsConfigSvc.getProperty('threshold_free_shipping').then(function (freeShippingValue) {
                if (!_.isNumber(freeShippingValue)) {
                    logger.log('freeShippingOver is not a number: ', freeShippingValue);
                    deferred.reject('freeShippingOver is not a number: ');
                } else {
                    var freeShipping = {
                        value: freeShippingValue,
                        show: false
                    };
                    if (freeShippingValue > shopCart.state.totalProduct) {
                        freeShipping.show = true;
                    }
                    deferred.resolve(freeShipping);
                }
            });

            return deferred.promise;
        }

        /**
         * @ngdoc method
         * @name hasVirtualCard
         * @methodOf common.shopCart.service:ItxShopCartFct
         * @description Check if user has a virtual card item
         *
         */
        function hasVirtualCard() {
            //_this.shopCart
            var hasVirtual =
                inditex.iUserJSON.shopCart.items.filter(function (item) {
                    return item.productType === 'Virtual Card';
                }).length > 0;
            return hasVirtual;
        }

        /**
         * @ngdoc method
         * @name checkShopcartMerge
         * @methodOf common.shopCart.service:ItxShopCartFct
         * @description
         * Check if the shop cart has been updated with more items.
         */
        function shopcartMerged(previousShopCart) {
            var shopcart = _this.shopCart;
            if (previousShopCart.items.length < shopcart.items.length) {
                return true;
            }
            if (previousShopCart.totalOrder != shopcart.totalOrder) {
                return true;
            }

            return false;
        }

        function _getGroupItemsByCode(data) {
            var wrapItemsLodash = _.chain(data.items).groupBy('stockLocations[0].stockSourceCode');
            var position = 1;
            return wrapItemsLodash
                .map(function (items, key) {
                    return {
                        stockSourceCode: key,
                        items: items,
                        index: position++
                    };
                })
                .value();
        }

        function _saveDataShopcart(shopCart) {
            const shopcartCopy = angular.copy(shopCart);

            if (shopcartCopy) {
                shopcartCopy.items = shopcartCopy.items.length > 0 ? _parseItems(shopcartCopy.items) : [];
                shopcartCopy.state = _getStateShopCart(shopcartCopy);
                ShopCartPackagingService.getStateGift(shopcartCopy).then(function (res) {
                    if (shopcartCopy.state) {
                        shopcartCopy.state.gift = res;
                    }
                    /* shopCart.state.gift = res; */
                    _setGlobalShopcart(shopcartCopy);
                });
            }
            return shopcartCopy;
        }

        function _setGlobalShopcart(shopCart) {
            inditex.iUserJSON.shopCart = shopCart;
            _validateCart(shopCart);
            // $rootScope.$broadcast('itx-shop-cart:updated', shopCart);
        }

        function _getStateShopCart(shopCart) {
            var errors = [];
            var state = {};
            state.itemsGroup = _getGroupItemsByCode(shopCart);
            state.subOrdersExceded = false;
            state.isEmpty = shopCart.items.length === 0;
            state.messageItem = _this.messages.notStock;
            state.totalItems = _getItemsQuantity(shopCart);
            state.totalProduct = _getTotalProduct(shopCart);

            if (shopCart.indomError) {
                switch (shopCart.indomError) {
                    case '116':
                        errors = _.concat(errors, '115');
                        // errors = _.concat(errors, '116');
                        // state.subOrdersExceded = true;
                        break;
                    case '117':
                        errors = _.concat(errors, '117');
                        state.messageItem = _this.messages.notAvailable;
                        break;
                    default:
                        errors = _.concat(errors, shopCart.indomError);
                        break;
                }
                console.error('ERROR EN CESTA INDOM ERROR ', shopCart.indomError);
                imEventServiceWrapper.sendServerUnidadeStock(null, shopCart);
            } else if (inditex.iPage === _this.shopCartPage) {
                if (
                    shopCart.items.filter(function (item) {
                        return (
                            item.availability !== 'in_stock' || item.quantity > item.unitsAvailable
                        );
                    }).length > 0
                ) {
                    shopCart.indomError = '115';
                    errors = _.concat(errors, shopCart.indomError);
                    imEventServiceWrapper.sendServerUnidadeStock(null, shopCart);
                } else if (_this.stockErrorMeccano == true) {
                    shopCart.indomError = 'errorStockMeccano';
                    errors = _.concat(errors, shopCart.indomError);
                    $(window).scrollTop(0);
                    imEventServiceWrapper.sendServerUnidadeStock(null, shopCart);
                }
            } else if (_this.stockErrorMeccano) {
                shopCart.indomError = 'errorStockMeccano';
                errors = _.concat(errors, shopCart.indomError);
                imEventServiceWrapper.sendServerUnidadeStock(null, shopCart);
            }

            // desagrupamos para no perder ordenación de productos sin stock
            if (state.subOrdersExceded) {
                state.renderItems = state.itemsGroup;
            } else {
                state.renderItems = shopCart.items;
            }

            state.errors = errors;
            return state;
        }

        function _handleErroShopcart(error) {
            if (error && error.data && error.data.key === '_ERR_CUSTOMIZATION_NOT_ALLOWED') {
                DialogSvc.open(error.data.description);
                inditex.removeLocalStorage('cache-pending-data');
                inditex.removeLocalStorage('cache-shop-cart');
            } else {
                ItxErrorMessagesFct.add(error, 'shopcart', 'ERROR');
            }
        }

        function _parseItems(items) {
            return _.map(items, function (item) {
                return new ItemCart(item);
            });
        }

        // Los items del CART son MOCACOTA (MOdelo CAlidad COlor TAlla)
        function ItemCart(item) {
            if (!item.state) {
                item.state = {};
            }
            item.state.xgift = item.name.indexOf('XGIFT') > -1;
            item.state.isCard =
                item.productType === 'Physical Card' || item.productType === 'Virtual Card';
            item.name = mdUtils.firstCapitalLetter(item.name);
            // Si el ITEM es de tipo MOCA(Product) parseamos los datos del MOCACOTA
            if (item.activeDetail) {
                // item.size = item.state.selectedSize.name;

                item.displayReference = item.activeDetail.displayReference;
                item.xmediaDefaultSet = item.activeDetail.xmediaDefaultSet;
                item.colors = item.activeDetail.colors;

                // TEST ITEM
                item.quantity = 1;
                item.unitsAvailable = 1;
                item.xmedia = item.activeDetail.xmedia;

                if (item.state.selectedColor) {
                    item.colorId = item.state.selectedColor.id;
                    item.image = item.state.selectedColor.image;
                } else {
                    item.colorId = item.mainColorid;
                }

                if (item.state.selectedSize) {
                    item.unitPrice = item.state.selectedSize.price;
                } else if (item.state.selectedColor) {
                    if (item.state.selectedSizeIndex) {
                        item.unitPrice =
                            item.state.selectedColor.sizes[item.state.selectedSizeIndex].price;
                    } else {
                        item.unitPrice = item.state.selectedColor.sizes[0].price;
                    }
                }

                // this.isItemHazardousGood = item.isItemHazardousGood;
                // this.itemType: item.itemType;
                // this.availability: item.availability,
                // this.unitsAvailable: item.unitsAvailable,
                // this.fromStore: item.fromStore,
            }
            return item;
        }
    }
})();